const removeActiveClassHelper = (elements: NodeListOf<Element>) => {
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    element.classList.remove('isActive');
  }
};

export default removeActiveClassHelper;
